export abstract class BaseController {
  protected socketSynchronizationHandlers: any = null
}
